<script setup>
const { t } = useI18n()
defineExpose({
  t,
})
</script>

<i18n>
{
  "en-us": {
    "Ages": "Ages",
    "Age": "Age",
    "over": "over",
    "under": "under"
  }
}
</i18n>


<i18n locale="de" lang="json">
{
  "Age": "Alter",
  "Ages": "Alter",
  "over": "über",
  "under": "unter"
}
</i18n>

<i18n locale="es" lang="json">
{
  "Age": "Edad",
  "Ages": "Edades",
  "over": "sobre",
  "under": "bajo"
}
</i18n>

<i18n locale="fr" lang="json">
{
  "Age": "Âge",
  "Ages": "Âges",
  "over": "plus de",
  "under": "sous"
}
</i18n>